import React from "react";
import { leaf, adBanner, mainLeaf, leaf2, smallFlower } from "../assets";
import { Link } from "react-router-dom";
import { BsBookmarkPlus, BsCheckLg } from "react-icons/bs";

const SingleTreatment = ({ singleTreat }) => {
  return (
    <div id="singleTreatment">
      <div className="gradient"></div>
      <div className="gradient2"></div>

      <img src={mainLeaf} alt="" className="fixedIO1" />
      <img src={leaf2} alt="" className="fixedIO2" />

      <img src={adBanner} alt="" className="bigBanner" />
      <div className="highLight">
        <div className="top">
          <div className="title">
            <img src={leaf} alt="" />
            <h1>{singleTreat.title}</h1>
          </div>
          <Link to="/appointment" className="booking">
            <small>Book Appointment</small>
          </Link>
        </div>
        <p className="details">{singleTreat.fulldesc}</p>

        <div className="features">
          <div className="feature active">
            <p>What you will get?</p>
            <small>Best treatment is waiting for you.</small>
          </div>
          <div className="feature">
            <img src={smallFlower} alt="" />
            <p>{singleTreat.benifit1}</p>

            <div>
              <div className="point"></div>
              <small>New Look</small>
            </div>
            <div>
              <div className="point"></div>
              <small>Improvements</small>
            </div>
          </div>
          <div className="feature">
            <img src={smallFlower} alt="" />
            <p>{singleTreat.benifit2}</p>

            <div>
              <div className="point"></div>
              <small>New Look</small>
            </div>
            <div>
              <div className="point"></div>
              <small>Improvements</small>
            </div>
          </div>
          <div className="feature">
            <img src={smallFlower} alt="" />
            <p>{singleTreat.benifit3}</p>

            <div>
              <div className="point"></div>
              <small>New Look</small>
            </div>
            <div>
              <div className="point"></div>
              <small>Improvements</small>
            </div>
          </div>
        </div>

        <div className="pre-cares">
          <h1>Pre Operation Care</h1>
          <p>
            Pre-operative care aims to minimize risks, optimize the patient's
            condition, and provide the necessary information and support to
            ensure a safe and successful surgical experience. It is a
            collaborative effort involving surgeons, anesthesiologists, nurses,
            and other healthcare professionals to prioritize patient well-being
            throughout the surgical process.
          </p>

          <div className="cares">
            <div className="care">
              <BsCheckLg className="check" />
              <small>
                <span style={{ fontWeight: "bold" }}>Medical Assessment: </span>
                Evaluate health and risks
              </small>
            </div>
            <div className="care">
              <BsCheckLg className="check" />
              <small>
                {" "}
                <span style={{ fontWeight: "bold" }}>Anesthesia Review: </span>
                Assess anesthesia suitability.
              </small>
            </div>
            <div className="care">
              <BsCheckLg className="check" />
              <small>
                <span style={{ fontWeight: "bold" }}>
                  Medication and Diet:{" "}
                </span>
                Adjust meds, fasting guidelines.
              </small>
            </div>
            <div className="care">
              <BsCheckLg className="check" />
              <small>
                <span style={{ fontWeight: "bold" }}>Informed Consent: </span>
                Explain procedure and obtain consent.
              </small>
            </div>
            <div className="care">
              <BsCheckLg className="check" />
              <small>
                <span style={{ fontWeight: "bold" }}>Safety Prep: </span>
                Ensure hygiene, attire, and safety checks. ipsum.
              </small>
            </div>
          </div>
        </div>

        <div className="patient-review">
          <div className="text-col">
            <img src={leaf} alt="" />
            <h1>Our Patient Review</h1>

            <p>
              Our patients with their valuable review. Our expert professionals
              pamper you, leaving you feeling refreshed, rejuvenated, and
              utterly satisfied. Unwind and indulge in the luxurious,
              transformative journey to beauty and self-care.
            </p>

            <Link to="/patient-results" className="viewAll">
              View all reviews
            </Link>
          </div>

          <div className="video-col">
            <iframe
              src="https://www.youtube.com/embed/i11TceowUT0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen="true"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleTreatment;
